import Backbone from 'backbone';
import dayjs from 'libraries/dayjs'
import DateFormatter from 'libraries/dateFormatter';

class ArchiveDate extends Backbone.Model {
    parse(response) {
        if (response.object) {
            return response.object;
        } else {
            return response;
        }
    }

    // TODO: TimelineController calls start from here, should be extracted to
    //       a facade. Model is not for timeline representation.
    getBeginningTimestamp() {
        return this.get('starts');
    }

    isCurrent() {
        var today = new Date();
        var date  = this._startsToDate();
        return today.getFullYear() === date.getFullYear() &&
               today.getMonth() === date.getMonth() &&
               today.getDate() === date.getDate();
    }

    isSame(day) {
        var date  = dayjs(this._startsToDate());
        return date.isSame(day.get('date'), 'day');
    }

    isAfter(day) {
        var date  = dayjs(this._startsToDate());
        return date.isAfter(day.get('date'), 'day');
    }

    isBefore(day) {
        var date  = dayjs(this._startsToDate());
        return date.isBefore(day.get('date'), 'day');
    }

    _startsToDate() {
        return new Date(this.get('starts') * 1000);
    }

    formattedDate() {
        let isLatestIssue =
            this.get('id') === this.collection.latestArchiveDateId();
        let date = this.get('delivery_time') * 1000;

        return DateFormatter.formatRelativeArchiveDate(date, isLatestIssue);
    }

    isUpcomingIssue() {
        let date = dayjs(this.get('delivery_time') * 1000);
        var now = dayjs();
        return date.isAfter(now);
    }

    // Whether the issue contains any articles. Used to decide if the
    // "Add automatic summary" button should be offered (an automatic table of
    // contents only makes sense for issues that actually have articles).
    //
    // This includes the upcoming issue, which collects articles continuously
    // (DEV-2994). We rely on a `results_count` attribute when the API provides
    // one; while it is absent we stay optimistic and show the button — the
    // backend still validates and returns an error (handled by the caller) for
    // genuinely empty issues, so nothing broken is ever saved.
    hasResults() {
        let count = this.get('results_count');
        if (count === undefined || count === null) {
            return true;
        }
        return count > 0;
    }
}

export default ArchiveDate;
